import { SET_GOOGLE_CONTACT } from "constants/app";

export const setGoogleContacts = (googleContacts) => async (dispatch) =>
  dispatch({
    type: SET_GOOGLE_CONTACT,
    googleContacts,
  });
